import { CdkColumnDef, CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { PopoverModule } from 'ngx-smart-popover';
import { AppCommonModule } from '../app-common.module';
import { AccountOverviewByDateComponent } from './account-overview/account-overview-by-date.component';
import { AgingReportComponent } from './aging/aging.report.component';
import { AvailableFundsSummaryRowComponent } from './available-funds-summary/available-funds-summary-row/available-funds-summary-row.component';
import { AvailableFundsSummaryComponent } from './available-funds-summary/available-funds-summary.component';
import { AvailableFundsSummaryExpandableContainer } from './available-funds-summary/expandable-container/available-funds-summary-expandable-container.component';
import { CheckNumberResultsReportComponent } from './collections/check-number-results.report.component';
import { CollectionsExpandableRowComponent } from './collections/collections.expandable-row.component';
import { CollectionsGroupedTableComponent } from './collections/collections.grouped-table.component';
import { CollectionsReportComponent } from './collections/collections.report.component';
import { CollectionsGroupedTableHeaderFooterComponent } from './collections/templates/collections.grouped-table-header-footer.component';
import { CollectionsMobileGroupedTableComponent } from './collections/templates/collections.mobile-grouped-table.component';
import { ExpensesPopoverColumnComponent } from './columns/expenses-popover-column.component';
import { FeePopoverColumnComponent } from './columns/fee-popover-column.component';
import { CreditRequestHistoryReportComponent } from './credit-request-history/credit-request-history.report.component';
import { FundingsReportComponent } from './fundings/fundings.report.component';
import { IneligiblesReportComponent } from './ineligibles/ineligibles.report.component';
import { InvoiceNumberResultsReportComponent } from './invoice-number-results/invoice-number-results.report.component';
import { PurchasesExpandableRowComponent } from './purchases/purchases.expandable-row.component';
import { PurchasesGroupedTableComponent } from './purchases/purchases.grouped-table.component';
import { PurchasesReportComponent } from './purchases/purchases.report.component';
import { PurchasesFundingTotalPopoverComponent } from './purchases/templates/purchases.funding-total-popover.component';
import { PurchasesGroupedTableHeaderComponent } from './purchases/templates/purchases.grouped-table-header.component';
import { PurchasesMobileGroupedTableComponent } from './purchases/templates/purchases.mobile-grouped-table.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';

@NgModule({
    imports: [
        AppCommonModule,
        ReportsRoutingModule,
        LsqCommonModule.forChild(),
        LsqTablesModule.forRoot(),
        PopoverModule,
        CdkTableModule
    ],
    declarations: [
        ReportsComponent,
        AvailableFundsSummaryComponent,
        AvailableFundsSummaryExpandableContainer,
        AvailableFundsSummaryRowComponent,
        AccountOverviewByDateComponent,
        AgingReportComponent,
        CheckNumberResultsReportComponent,
        CreditRequestHistoryReportComponent,
        FundingsReportComponent,
        IneligiblesReportComponent,
        InvoiceNumberResultsReportComponent,
        FeePopoverColumnComponent,
        ExpensesPopoverColumnComponent,

        // Purchases:
        PurchasesReportComponent,
        PurchasesExpandableRowComponent,
        PurchasesGroupedTableComponent,
        PurchasesFundingTotalPopoverComponent,
        PurchasesGroupedTableHeaderComponent,
        PurchasesMobileGroupedTableComponent,

        // Collections:
        CollectionsReportComponent,
        CollectionsExpandableRowComponent,
        CollectionsGroupedTableComponent,
        CollectionsGroupedTableHeaderFooterComponent,
        CollectionsMobileGroupedTableComponent
    ],
    exports: [
        AvailableFundsSummaryComponent,
        AvailableFundsSummaryExpandableContainer,
        AvailableFundsSummaryRowComponent,
        CollectionsGroupedTableComponent
    ],
    providers: [CdkColumnDef]
})
export class ReportsModule {}
